import {
  Button,
  TextField,
} from "@mui/material";
import { Box, Popover } from "@mui/material";
import React, { useEffect, useState, useRef, memo, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loaderStartActionCreater } from "../../Redux/Loader/LoaderActionCreator";
import { openSnackbar } from "../../Redux/Snackbar/snackbarStore";
import CustomSlider from "../CustomSlider/CustomSlider";
import { MultipleElasticSearch } from "./multipleAdvanceSearch ";
// import { MultipleSearch } from "./multipleSearch";
// import StateCity from "../Data/StateCity";
// import { city } from "../Data/maharashtraCity";
import _ from "lodash";
import statesDistrictsTalukas from "../../../src/Components/Data/statesDistrictTalukas.json";

const CustomSearch = forwardRef((props, ref) => {
  const {
    data,
    setTableData,
    setFinalAdvanceSearchData,
    rangeSearchCol,
    columns,
    setOptionVal,
    simpleSearchCol,
    // tableData,
    moduleName,
    isAction,
    setIsAction,
    finalAdvanceSearchData,
    // New props for API search
    optionVal,
    searchMembers,
    isSearching,
    searchTerm,
    setSearchTerm,
    clearSearch,
    // Advanced search props
    advancedSearchFilters,
    setAdvancedSearchFilters,
    rangeSearchFilters,
    setRangeSearchFilters,
    handleAdvancedSearchChange,
    handleRangeSearchChange,
    triggerAdvancedSearch,
    clearAdvancedSearch,
  } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [dropdownData, setDropdownData] = useState();
  const [searchData, setSearchData] = useState({});
  // const [stateList, setStateList] = useState();
  // const [maharashtraDistList, setMaharashtraDistList] = useState();
  // const [maharashtraTalukaList, setMaharashtraTalukaList] = useState();
  const [memberType, setMemberType] = useState([]);
  const [shareHolderType, setShareHolderType] = useState([]);
  const states = _.keysIn(statesDistrictsTalukas).map((state) => state);

  const getConfigData = useSelector((state) => {
    return state.configuration;
  });

  // console.log(ref?.current?.state?.data);
  // console.log("simpleSearchCol!!", simpleSearchCol);
  // console.log("In Custom search::",data);
  //get state list

  // const sliderMaxVal = (col) => {
  //   // let maxValue = data?.reduce((arr, a) => {
  //   // console.log(ref);
  //   // console.log(ref?.current?.state?.data);
  //   // let maxValue = ref?.current?.state?.data?.reduce((arr, a) => {
  //   let maxValue = tableData?.reduce((arr, a) => {
  //     return [...arr, parseInt(a[col])];
  //   }, []);
  //   // console.log(maxValue);
  //   if (maxValue) maxValue = Math?.max(...maxValue);
  //   // console.log(maxValue);
  //   return maxValue;
  // };

  const [allVal, setAllVal] = useState(
    rangeSearchCol?.reduce((stateVal, col) => {
      stateVal[col[0]] = [0, 0];
      return stateVal;
    }, {})
  );

  const [allCheckbox, setAllCheckbox] = useState(
    rangeSearchCol?.reduce((stateVal, col) => {
      stateVal[col[0]] = false;
      return stateVal;
    }, {})
  );

  const searchVal = useRef(null);
  const dispatch = useDispatch();

  const arrowHandleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const arrowHandleClose = () => {
    setAnchorEl(null);
  };

  const openP = Boolean(anchorEl);
  const id = openP ? "simple-popover" : undefined;

  useEffect(() => {
    // Build comprehensive dropdown data using both API data and static data sources
    if (finalAdvanceSearchData?.length > 0) {
      // Get unique values from current API data
      let dropData = finalAdvanceSearchData?.reduce((ans, val) => {
        let dummyDq = ans;
        simpleSearchCol?.map((ele) => {
          // Skip null/undefined values and ensure unique values
          if (val[ele[1]] !== null && val[ele[1]] !== undefined && val[ele[1]] !== '') {
            dummyDq[ele[1]] = dummyDq[ele[1]]?.includes(val[ele[1]])
              ? dummyDq[ele[1]]
              : dummyDq[ele[1]]
              ? [...dummyDq[ele[1]], val[ele[1]]]
              : [val[ele[1]]];
          }
        });
        return dummyDq;
      }, {});

      // console.log("🏗️ Building comprehensive dropdown data");
      
      // Use comprehensive data sources (same as CreateMemberForm)
      dropData.state = states; // Complete state list from JSON
      
      // Get all districts from all states
      const allDistricts = [];
      Object.values(statesDistrictsTalukas).forEach(stateData => {
        stateData.forEach(item => {
          if (item.DISTRICT && !allDistricts.includes(item.DISTRICT)) {
            allDistricts.push(item.DISTRICT);
          }
        });
      });
      dropData.district = allDistricts.sort();
      
      // Get all talukas from all states
      const allTalukas = [];
      Object.values(statesDistrictsTalukas).forEach(stateData => {
        stateData.forEach(item => {
          if (item.TEHSIL && !allTalukas.includes(item.TEHSIL)) {
            allTalukas.push(item.TEHSIL);
          }
        });
      });
      dropData.taluka = allTalukas.sort();
      
      // Keep API data for other fields but ensure they exist
      dropData.city = dropData.city || [];
      dropData.organisation_name = dropData.organisation_name || [];
      dropData.pincode = dropData.pincode || [];
      dropData.member = memberType || []; // Use configuration data
      dropData.shareholder = shareHolderType || []; // Use configuration data
      dropData.mobileStatus = ["Enabled", "Disabled"]; // Static options
      dropData.activity = ["Active", "Inactive"]; // Static options
      
      // console.log("📊 Complete dropdown data:", dropData);
      setDropdownData(dropData);
    }
  }, [finalAdvanceSearchData, memberType, shareHolderType, openP]);

  useEffect(() => {
    // console.log(getConfigData);
    setMemberType(
      getConfigData?.memberType?.map((e) => {
        return e.type;
      })
    );
    setShareHolderType(
      getConfigData?.shareholderType?.map((e) => {
        return e.type;
      })
    );
  }, [getConfigData]);

  const customSearch = () => {
    if (
      rangeSearchCol
        ?.filter(([colName, realCol]) => allCheckbox[colName])
        .some(([colName, realCol]) => allVal[colName][0] > allVal[colName][1])
    ) {
      dispatch(
        openSnackbar("Minimum value cannot be greater than Maximum", "error")
      );
    } else {
      // If we have advanced search functions, use them
      if (triggerAdvancedSearch && handleAdvancedSearchChange && handleRangeSearchChange) {
        // console.log("🎯 Using advanced search with API");
        
        // Update the advanced search filters with current dropdown values
        Object.keys(searchData).forEach(key => {
          if (searchData[key] && searchData[key].length > 0) {
            handleAdvancedSearchChange(key, searchData[key]);
          }
        });
        
        // Update range search filters with current slider values
        rangeSearchCol?.forEach(([colName, realCol]) => {
          if (allCheckbox[colName]) {
            handleRangeSearchChange(realCol, allVal[colName]);
          }
        });
        
        // Trigger the API search
        triggerAdvancedSearch();
        arrowHandleClose();
        return;
      }
      
      // Fallback to original client-side search
      console.log("📝 Using client-side search");
      dispatch(loaderStartActionCreater());
      
      let newData = data?.filter((item) =>
        rangeSearchCol
          ?.filter(([colName, realCol]) => allCheckbox[colName])
          .every(
            ([colName, realCol]) =>
              item[realCol] >= allVal[colName][0] &&
              item[realCol] <= allVal[colName][1]
          )
      );

      newData = newData?.filter((ele) => {
        return Object.keys(searchData)?.reduce((ans, val) => {
          return (
            (searchData[`${val}`]?.length <= 0 && ans) ||
            (searchData[`${val}`]?.some((e) => {
              return e?.toLowerCase() === ele[`${val}`]?.toLowerCase();
            }) &&
              ans)
          );
        }, true);
      });

      arrowHandleClose();
      setTableData(newData);
      if (setFinalAdvanceSearchData) setFinalAdvanceSearchData(newData);
    }
  };

  const allSearch = () => {
    const searchValue = searchVal.current?.value.trim();
    console.log("🔎 CustomSearch allSearch called with:", searchValue);
    
    // Always use API search when searchMembers function is available (Members page)
    if (searchMembers) {
      console.log("🎯 Using API search - calling searchMembers");
      
      // Update search term immediately for UI responsiveness
      if (setSearchTerm) {
        setSearchTerm(searchValue);
      }
      
      // Debounce API calls to prevent excessive requests
      clearTimeout(window.searchTimeout);
      window.searchTimeout = setTimeout(() => {
        console.log("⏰ Debounced search executing for:", searchValue);
        searchMembers(searchValue);
      }, 300); // 300ms debounce
      
      return;
    }
    
    console.log("📝 Using client-side search");
    // Fallback to client-side search for other components that don't have API search
    if (searchValue !== "") {
      let newData = finalAdvanceSearchData?.filter((rowData) =>
        columns.some((col) => {
          if (col.customFilterAndSearch) {
            return col.customFilterAndSearch(searchValue, rowData);
          } else if (col.render) {
            let renderText = col.render(rowData);
            if (typeof renderText === "object")
              renderText = renderText.props.children;
            return (
              renderText
                .toLowerCase()
                .indexOf(searchValue.toLowerCase()) > -1
            );
          } else {
            return (
              rowData[col.field]
                ?.toString()
                .toLowerCase()
                .indexOf(searchValue.toLowerCase()) > -1
            );
          }
        })
      );

      setTableData(newData);
    } else {
      setTableData(finalAdvanceSearchData);
    }
  };

  const handleClear = () => {
    // Clear any pending search timeouts
    clearTimeout(window.searchTimeout);
    
    // Clear API search if searchMembers function is available
    if (searchMembers && clearSearch) {
      clearSearch();
    }
    
    // Clear advanced search if function is available
    if (clearAdvancedSearch) {
      clearAdvancedSearch();
    }
    
    // Clear search input
    if (searchVal.current) {
      searchVal.current.value = "";
    }
    
    // Clear search term state
    if (setSearchTerm) {
      setSearchTerm("");
    }
    
    // Reset client-side data for non-API components
    if (!searchMembers) {
      setTableData(data);
      if (setFinalAdvanceSearchData) setFinalAdvanceSearchData(data);
    }
    
    // Clear all local dropdown states
    setSearchData({});
    
    // Reset range slider values
    setAllVal(
      rangeSearchCol?.reduce((stateVal, col) => {
        stateVal[col[0]] = [0, 0];
        return stateVal;
      }, {})
    );
    
    // Reset range slider checkboxes
    setAllCheckbox(
      rangeSearchCol?.reduce((stateVal, col) => {
        stateVal[col[0]] = false;
        return stateVal;
      }, {})
    );
    
    console.log("🧹 All filters cleared");
  };

  useEffect(() => {
    // console.log("In", isAction);
    customSearch();
    if (isAction) setIsAction(false);
  }, [isAction]);

  // Sync local state with advanced search filters when they are cleared
  useEffect(() => {
    if (advancedSearchFilters) {
      // Check if all advanced search filters are empty/cleared
      const allFiltersEmpty = Object.values(advancedSearchFilters).every(
        value => value === "" || value === null || value === undefined
      );
      
      if (allFiltersEmpty) {
        // console.log("🔄 Syncing: Advanced filters cleared, clearing local dropdown state");
        setSearchData({});
        
        // Also reset range filters
        if (rangeSearchFilters) {
          const allRangeFiltersEmpty = Object.values(rangeSearchFilters).every(
            value => Array.isArray(value) && value[0] === 0 && value[1] === 0
          );
          
          if (allRangeFiltersEmpty) {
            setAllVal(
              rangeSearchCol?.reduce((stateVal, col) => {
                stateVal[col[0]] = [0, 0];
                return stateVal;
              }, {})
            );
            setAllCheckbox(
              rangeSearchCol?.reduce((stateVal, col) => {
                stateVal[col[0]] = false;
                return stateVal;
              }, {})
            );
          }
        }
      }
    }
  }, [advancedSearchFilters, rangeSearchFilters]);

  // console.log("itemList=", searchData);
  // console.log("maharashtraTalukaList", maharashtraTalukaList);

  useEffect(() => {
    // console.log("Hit state in advance Search::");
    let districts = searchData?.state?.reduce((ans, ele) => {
      return [...ans, ...statesDistrictsTalukas[`${ele}`]];
    }, []);

    districts = districts?.reduce((ans, ele) => {
      return ans?.includes(ele["DISTRICT"] || "")
        ? ans
        : [...ans, ele["DISTRICT"]];
    }, []);

    // console.log(districts || []);
    setDropdownData({ ...dropdownData, district: districts || [] });
  }, [searchData.state]);

  useEffect(() => {
    // console.log("Hit taluka in advance Search::");
    let talukas = searchData?.state?.reduce((ans, ele) => {
      return [...ans, ...statesDistrictsTalukas[`${ele}`]];
    }, []);

    talukas = searchData?.district?.reduce((ans, ele) => {
      return [
        ...ans,
        ...talukas.filter((e) => {
          return e["DISTRICT"] === ele;
        }),
      ];
    }, []);

    talukas = talukas?.map((ele) => {
      return ele["TEHSIL"];
    });
    // console.log(talukas || []);
    setDropdownData({ ...dropdownData, taluka: talukas || [] });
  }, [searchData.district]);

  return (
    <>
      <TextField
        id="outlined-search"
        className="searchBox"
        type="search"
        placeholder="Search"
        inputRef={searchVal}
        onChange={allSearch}
        value={searchMembers && searchTerm ? searchTerm : undefined}
        InputProps={{
          endAdornment: (
            <i
              className="fa fa-caret-down"
              onClick={arrowHandleClick}
              style={{ fontSize: "20px", color: "#787878", cursor: "pointer" }}
            />
          ),
          startAdornment: (
            <i className="fa fa-search" style={{ color: "#858585" }} />
          ),
        }}
        sx={{
          backgroundColor: "#f6f6f6",
          borderRadius: "5px",
          "& input": {
            padding: "10px",
          },
          "& fieldset": {
            display: "none",
          },
        }}
      />

      {openP ? (
        <Popover
          id={id}
          open={openP}
          anchorEl={anchorEl}
          onClose={arrowHandleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <Box
            sx={{
              width: `${simpleSearchCol ? "60rem" : "50rem"}`,
              // width: "60rem",
              overFlow: "auto",
              maxHeight: "80vh",
            }}
          >
            <div
              style={{
                display: "grid",
                gap: "10px",
                width: "100%",
                padding: "20px 30px 20px",
                alignItems: "center",
                overFlow: "auto",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  width: "100%",
                  padding: "10px 10px",
                  justifyContent: "space-between",
                }}
              >
                {rangeSearchCol?.map((col, i) => (
                  <CustomSlider
                    key={i}
                    data={data}
                    col={col}
                    ref={ref}
                    allVal={allVal}
                    setAllVal={setAllVal}
                    allCheckbox={allCheckbox}
                    setAllCheckbox={setAllCheckbox}
                    moduleName={moduleName}
                    // New props for advanced search
                    rangeSearchFilters={rangeSearchFilters}
                    handleRangeSearchChange={handleRangeSearchChange}
                  />
                ))}
              </div>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  justifyContent: "space-evenly",
                  overflow: "auto",
                }}
              >
                {dropdownData
                  ? simpleSearchCol?.map((ele, i) => {
                      {
                        /* ele[1] === "district" ? searchData.state.includes("Maharashtra") ? [...maharashtraDistList,...dropdownData[ele[1]].filter((ele) => {
                            return ele != null && ele != "";
                          })}] : regular : ele[1] === "taluka" ? searchData.state.includes("Maharashtra") ? maharashtraTalukaList[`${searchData[ele[1]]}`] : regular : regular */
                      }
                      return (
                        <MultipleElasticSearch
                          key={i}
                          title={ele[0]}
                          setSearchData={setSearchData}
                          searchData={searchData}
                          keyValue={ele[1]}
                          // New props for advanced search
                          advancedSearchFilters={advancedSearchFilters}
                          handleAdvancedSearchChange={handleAdvancedSearchChange}
                          itemList={dropdownData[ele[1]]?.filter((ele) => {
                            return ele !== null && ele !== "";
                          })}
                        />
                      );
                    })
                  : ""}
              </div>
            </div>

            <hr className="m-0" />
            <div
              style={{
                padding: "20px 20px 20px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>
                <Button
                  variant="contained"
                  onClick={handleClear}
                  sx={{
                    bgcolor: "#0096FF",
                  }}
                >
                  Clear
                </Button>
              </div>
              <div>
                <Button onClick={arrowHandleClose}>Cancel</Button>
                <Button
                  variant="contained"
                  onClick={customSearch}
                  sx={{
                    bgcolor: "#0096FF",
                  }}
                >
                  Search
                </Button>
              </div>
            </div>
          </Box>
        </Popover>
      ) : (
        ""
      )}
    </>
  );
});

export default memo(CustomSearch);
